import Container from 'react-bootstrap/Container';
import './Footer.scss';
import telegram from '../../assets/telegram.svg';
import medium from '../../assets/medium.svg';
import twitter from '../../assets/twitter.svg';

const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <div className="footer__container">
          <div>
            Part of the&nbsp;
            <a href="https://finance.vote" target="_blank" rel="noreferrer">
              finance.vote
            </a>
            &nbsp;dApp suite. 2021 All rights reserved
          </div>
          <div className="footer__links">
            <a href="https://t.me/financedotvote" target="_blank" rel="noreferrer">
              <img src={telegram} alt="Telegram" />
            </a>
            <a href="https://twitter.com/financedotvote" target="_blank" rel="noreferrer">
              <img src={twitter} alt="Twitter" />
            </a>
            <a href="https://medium.com/@financedotvote" target="_blank" rel="noreferrer">
              <img src={medium} alt="Medium" />
            </a>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
